import React from "react";
import { round } from "../utils";
import { Store } from "../store";

export default function Price ({ listing, className, value }) {
  const config = Store.useState(s => s.config);
  const symbol = config.currencySymbol;
  const position = config.currencySymbolPosition;
  const showPricesBeforeTaxes = config.taxes.rules.showPricesBeforeTaxes;
  const valueToDisplay = round(listing ? (showPricesBeforeTaxes ? listing.prices.beforeTaxes : listing.prices.sale) : value);

  return (
    <span className={`price ${className || ""}`}>
      {position === "before" ? (
        <>
          {symbol}
          {valueToDisplay}
        </>
      ) : (
        <>
          {valueToDisplay}
          {symbol}
        </>
      )}
    </span>
  );
}
